import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getBreachRecordList as getBreachRecordListApi,
	getBreachRecordListQuery as getBreachRecordListQueryApi,
	getBreachRecordByIdApi,
	addNewBreachRecordApi,
	updateBreachRecordApi,
	deleteBreachRecordApi,
} from '../../helpers/breach_record/api_helper';

export const getBreachRecordList = createAsyncThunk(
	'breachRecord/getBreachRecordList',
	async params => {
		try {
			const response = await getBreachRecordListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener incumplimientos.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewBreachRecord = createAsyncThunk(
	'breachRecord/addNewBreachRecord',
	async breachRecord => {
		try {
			const response = await addNewBreachRecordApi(breachRecord);
			toast.success('Incumplimiento agregado correctamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateBreachRecord = createAsyncThunk(
	'breachRecord/updateBreachRecord',
	async breachRecord => {
		try {
			const response = await updateBreachRecordApi(breachRecord);
			toast.success('Incumplimiento actualizado correctamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getBreachRecord = createAsyncThunk(
	'breachRecord/getBreachRecord',
	async id => {
		try {
			const response = await getBreachRecordByIdApi(id);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener incumplimiento.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteBreachRecord = createAsyncThunk(
	'breachRecord/deleteBreachRecord',
	async breachRecord => {
		try {
			await deleteBreachRecordApi(breachRecord._id);
			toast.success('Incumplimiento eliminado correctamente.', {
				autoClose: 3000,
			});
			return breachRecord;
		} catch (error) {
			toast.error('Error al eliminar incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getBreachRecordListQuery = createAsyncThunk(
	'breachRecord/getBreachRecordListQuery',
	async params => {
		try {
			const response = await getBreachRecordListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);
